<div *ngIf="tableRegistrations">
    <pla-search-result-table [showCount]="true" [headerText]="'Recently Added'" [results]="tableRegistrations"
        [searching]="loading" [showFilter]="false" [showSort]="false" [showToggle]="false" [showFullSeries]="true" [metaText]="'date_added'"
        [paginationPageSize]="100"></pla-search-result-table>
</div>